/* eslint-disable react/jsx-key */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectFileIndex, selectFilesToUpload, selectImportEntity, selectImportWorkspace, selectMaxSeverity, selectMinSeverity, selectResolveHost, selectUploadState } from 'store/ManageEditCreate/selectors';
import Wrapper from './styled';
import Body from './components/Body';
import Header from './components/Header';
import { uploadFile } from 'Screens/Contextualization/ManageEditCreate/actions/Actions';
import { selectProcessingQueueIsExpanded } from 'store/FileUploaderContext/selector';
import { buildUploadParams } from 'Screens/Contextualization/ManageEditCreate/components/ImportFileCreationModal/utils';

const FileUploadContext = () => {
  const showBody = useSelector(selectProcessingQueueIsExpanded);
  const uploadState = useSelector(selectUploadState);
  const files = useSelector(selectFilesToUpload);
  const fileIndex = useSelector(selectFileIndex);
  const resolveHost = useSelector(selectResolveHost);
  const workspace = useSelector(selectImportWorkspace);
  const minSeverity = useSelector(selectMinSeverity);
  const maxSeverity = useSelector(selectMaxSeverity);
  const importEntity = useSelector(selectImportEntity);
  const dispatch = useDispatch();

  useEffect(() => {
    if (uploadState === 'PROCESSED' && fileIndex >= 0) {
      const params = buildUploadParams({
        entity: importEntity,
        file: files[fileIndex],
        resolveHost,
        minSeverity,
        maxSeverity
      });
      dispatch(uploadFile(params, workspace));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, uploadState]);

  return (
    <Wrapper>
      <Header showBody={ showBody } />
      {showBody && <Body /> }
    </Wrapper>
  );
};

export default FileUploadContext;
